module.exports = __webpack_public_path__ + "static/media/figli.f774f6ee.jpg";